<template>
  <div class="inquiry">
    <TheFilters
      :inquiry="inquiry"
      :activeTab="activeTab"
      :reports="reports"
      :queryObject="queryObject"
      :isInquiryMade="isInquiryMade"
      @setActiveObjects="activeObjects = $event"
      @setFormatedFromDate="formatedFromDate = $event"
      @setFormatedToDate="formatedToDate = $event"
      @getInquiry="checkPeriod()"
      @reset="resetReports()"
      @resetInquiry="resetInquiry()"
      @exportToExcelFile="exportToExcelFile()"
    />

    <div
      class="no-reports"
      v-if="isInquiryMade && !reports.length && !getLoading"
      ref="no-reports"
    >
      <p>{{ $t("inquiry-no-reports") }}</p>
    </div>
    <div class="no-reports" v-if="getLoading">
      <p>{{ $t("inquiry-loading") }}</p>
      <img class="loading" src="../assets/img/loading_dark.svg" alt="loading" />
    </div>
    <div class="reports" v-if="reports.length && isInquiryMade">
      <div class="reports-tabs">
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 0 }"
          @click="selectTab(0)"
        >
          <span>{{ $t("reports") }}</span>
          <span>({{ reports.length }})</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 1 }"
          @click="selectTab(1)"
        >
          <span>{{ $t("materials") }}</span>
          <span>({{ totalMaterialQuantity }})</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 2 }"
          @click="selectTab(2)"
        >
          <span>{{ $t("activities") }}</span>
          <span>({{ totalActivityQuantity }})</span>
        </button>
        <!-- <button
          class="reports-tab"
          :class="{ 'reports-tab-active' : activeTab === 3 }"
          @click="selectTab(3)"
        >
          <span>{{ $t('mechanizations') }}</span>
          <span v-if="!this.inquiry.worker._id">({{totalMechanizationQuantity}})</span>
        </button> -->
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 4 }"
          @click="selectTab(4)"
        >
          <span class="desktop">{{ $t("WorkersGroup") }}</span>
          <span class="mobile">{{ $t("Workers-mobile") }}</span>
          <span>({{ totalWorkersGroups }})</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 3 }"
          @click="selectTab(3)"
        >
          <span>{{ $t("summary") }}</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 5 }"
          @click="selectTab(5)"
        >
          <span>Заработки</span>
        </button>
      </div>
      <div class="reports-content">
        <!-- REPORTS -->
        <div class="table-wrapper">
          <table class="table" ref="reportsTable" v-show="activeTab === 0">
            <thead>
              <tr>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("date") | capitalize }}
                    <section
                      class="sorting"
                      :class="{ 'sorting--active': isSortingActive('date') }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('date', 1)"
                        :class="{ 'tms--active': isSortingActive('date', 1) }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('date', -1)"
                        :class="{ 'tms--active': isSortingActive('date', -1) }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("reporter") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('createdBy.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("company") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive(
                          'company.companyName'
                        ),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("site") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('object.objectName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("part") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('part.partName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', 1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', -1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <!-- <th class="center">Отчетени<br>&nbsp;хора&nbsp;</th>
                <th class="center">Общо отчетено<br>&nbsp;време&nbsp;</th>-->
                <th class="center">
                  <template v-if="inquiry.search">{{
                    $t("filtered")
                  }}</template>
                  <template v-else>{{ $t("reported") }}</template>
                  <br />
                  &nbsp;{{ $t("materials") }}&nbsp;
                </th>
                <th class="center">
                  <template v-if="inquiry.search">{{
                    $t("filtered")
                  }}</template>
                  <template v-else>{{ $t("reported") }}</template>
                  <br />
                  &nbsp;{{ $t("activities") }}&nbsp;
                </th>
                <th>Общо лв. от отчета</th>
                <th>Обща сума Заработки</th>
                <!-- <th class="center">
                  <template v-if="inquiry.search">{{ $t('filtered') }}</template>
                  <template v-else>{{ $t('reported') }}</template>
                  <br />
                  &nbsp;{{ $t('mechanizations') }}&nbsp;
                </th> -->
                <th
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin
                  "
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(r, ri) in reports"
                :key="`report-${r._id}-${ri}`"
                @click="goToReport(r._id)"
                :class="{ 'tr-invalid': r.isInvalid }"
              >
                <td :rowspan="r.mergeRows" v-if="!r.alreadyMerged">
                  <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                </td>
                <td :rowspan="r.mergeRows" v-if="!r.alreadyMerged">
                  <span>{{ r.createdBy.name }}</span>
                </td>
                <td
                  class="td-company-name"
                  :rowspan="r.mergeRows"
                  v-if="!r.alreadyMerged"
                >
                  <img
                    class="td-invalid-flag"
                    v-if="r.isInvalid"
                    src="../assets/img/flag_yes.svg"
                    alt="invalid"
                  />
                  {{ r.company.companyName }}
                </td>
                <!-- <td>{{r.project.projectName}}</td> -->
                <td :rowspan="r.mergeRows" v-if="!r.alreadyMerged">
                  {{ r.object.objectName }}
                </td>
                <td :class="{ 'not-first': r.alreadyMerged }">
                  {{ r.part.partName }}
                </td>
                <!-- <td class="center"> -->
                <!-- {{report.workers.length}} -->
                <!-- </td> -->
                <!-- <td class="center"> -->
                <!-- Look here -->
                <!-- <div class="worktime-indicator-wrapper">
                    <p
                      v-if="calculateHours(report.date, report.startHour, report.endHour).normal * report.workers.length"
                    >
                      <span class="worktime-indicator">НРВ</span>
                      {{calculateHours(report.date, report.startHour, report.endHour).normal * report.workers.length}} ч.
                    </p>
                    <p
                      v-if="calculateHours(report.date, report.startHour, report.endHour).overtime * report.workers.length"
                    >
                      <span class="worktime-indicator overtime-indicator">ИРВ 1</span>
                      {{calculateHours(report.date, report.startHour, report.endHour).overtime * report.workers.length}} ч.
                    </p>
                    <p
                      v-if="calculateHours(report.date, report.startHour, report.endHour).holiday * report.workers.length"
                    >
                      <span class="worktime-indicator holiday-indicator">ИРВ 2</span>
                      {{calculateHours(report.date, report.startHour, report.endHour).holiday * report.workers.length}} ч.
                    </p>
                </div>-->
                <!-- </td> -->
                <td class="center">
                  <template v-if="r.materials">{{
                    r.materials.length
                  }}</template>
                </td>
                <td class="center">
                  <template v-if="r.activities">{{
                    r.activities.length
                  }}</template>
                </td>
                <!-- <td class="center">
                  <template v-if="r.mechanizations">{{r.mechanizations.length}}</template>
                </td> -->
                <td>{{ r.reportTotalSum }}</td>
                <td>{{ r.reportTotalZarabotka }}</td>
                <td
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin
                  "
                >
                  <img
                    class="flag-indicator"
                    v-if="r.priceStatus === 2"
                    src="../assets/img/green.svg"
                    :alt="$t('all-amounts-entered')"
                    :title="$t('all-amounts-entered')"
                  />
                  <img
                    class="flag-indicator"
                    v-else-if="r.priceStatus === 1"
                    src="../assets/img/yellow.svg"
                    :alt="$t('missing-amounts-entered')"
                    :title="$t('missing-amounts-entered')"
                  />
                  <img
                    class="flag-indicator"
                    v-else-if="r.priceStatus === 0"
                    src="../assets/img/red.svg"
                    :alt="$t('no-amounts-entered')"
                    :title="$t('no-amounts-entered')"
                  />
                </td>
              </tr>
              <tr v-if="isInquiryMade && !reports.length">
                <td colspan="9" class="td-center">
                  {{ $t("inquiry-no-reports") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- MATERIALS -->
        <div class="table-wrapper">
          <table class="table" ref="materials" v-show="activeTab === 1">
            <thead>
              <tr>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("date") | capitalize }}
                    <section
                      class="sorting"
                      :class="{ 'sorting--active': isSortingActive('date') }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('date', 1)"
                        :class="{ 'tms--active': isSortingActive('date', 1) }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('date', -1)"
                        :class="{ 'tms--active': isSortingActive('date', -1) }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("reporter") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('createdBy.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("company") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive(
                          'company.companyName'
                        ),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("site") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('object.objectName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("part") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('part.partName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', 1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', -1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("material") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('materials.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('materials.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('materials.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('materials.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('materials.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  {{ $t("user-vas") }}
                </th>
                <th>{{ $t("quantity") }}</th>
                <th>{{ $t("metric-unit") }}&nbsp;</th>
                <th>{{ $t("price-one") }}</th>
                <th
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin
                  "
                >
                  {{ $t("total") }} {{ $t("currency") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <template v-for="(m, mi) in r.materials">
                  <tr
                    v-for="(w, i) in r.workers"
                    :key="`r-${r._id}-ma-${m._id}-${i}-matNum-${mi}-wo-${w._id}`"
                    @click="goToReport(r._id)"
                    :class="{
                      'tr-invalid': r.isInvalid,
                      'additional-row': m.isAdditional,
                    }"
                  >
                    <td>
                      <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                    </td>
                    <td>{{ r.createdBy.name }}</td>
                    <td>{{ r.company.companyName }}</td>
                    <td>{{ r.object.objectName }}</td>
                    <td>{{ r.part.partName }}</td>
                    <td>
                      <span v-if="m.isAdditional">⚡</span>
                      {{ m.name }}
                    </td>
                    <td class="ma-cell-name">
                      <div class="name-wrapp">
                        <template v-if="!exportingExcel">
                          <span
                            class="tms tms--blue tms--role"
                            v-if="w.permissions"
                            >y</span
                          >
                          <span class="tms tms--blue tms--role" v-else>0</span>
                        </template>
                        <span>{{ w.name }}</span>
                      </div>
                    </td>
                    <td>
                      <p v-if="w.users">
                        {{
                          (
                            (+m.quantity / w.totalWorkers) *
                            w.users.length
                          ).toFixed(2)
                        }}
                      </p>
                      <p v-else>
                        {{ (+m.quantity / w.totalWorkers).toFixed(2) }}
                      </p>
                    </td>
                    <td>{{ m.unit }}</td>
                    <td>{{ m.price }}</td>
                    <td
                      v-if="
                        getUser.permissions.isSuperAdmin ||
                        getUser.permissions.isAdmin
                      "
                    >
                      <p v-if="w.users">
                        {{
                          (
                            (+m.quantity / w.totalWorkers) *
                            +m.price *
                            w.users.length
                          ).toFixed(2)
                        }}
                      </p>
                      <p v-else>
                        {{
                          ((+m.quantity / w.totalWorkers) * +m.price).toFixed(2)
                        }}
                      </p>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-if="isInquiryMade && !totalMaterialQuantity">
                <td colspan="11" class="td-center">
                  {{ $t("inquiry-no-materials") }}
                </td>
              </tr>
              <tr
                class="sum-row"
                v-if="
                  getUser.permissions.isSuperAdmin ||
                  getUser.permissions.isAdmin
                "
              >
                <td colspan="10">{{ $t("total") }}:</td>
                <td>{{ totalMaterials.toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ACTIVITIES -->
        <div class="table-wrapper">
          <table class="table" ref="activities" v-show="activeTab === 2">
            <thead>
              <tr>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("date") | capitalize }}
                    <section
                      class="sorting"
                      :class="{ 'sorting--active': isSortingActive('date') }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('date', 1)"
                        :class="{ 'tms--active': isSortingActive('date', 1) }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('date', -1)"
                        :class="{ 'tms--active': isSortingActive('date', -1) }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("reporter") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('createdBy.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("company") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive(
                          'company.companyName'
                        ),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("site") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('object.objectName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("part") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('part.partName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', 1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', -1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("activity") }}
                    <section
                      class="sorting"
                      :class="{ 'sorting--active': smrSort !== undefined }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting(null, null, true)"
                        :class="{ 'tms--active': smrSort }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting(null, null, false)"
                        :class="{ 'tms--active': !smrSort }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  {{ $t("user-vas") }}
                </th>
                <th>{{ $t("note") }}</th>
                <th>{{ $t("metric-unit") }}</th>
                <th>{{ $t("price-one") }}</th>
                <th>{{ $t("real") }}</th>
                <th>{{ $t("planned") }}</th>
                <th
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin
                  "
                >
                  {{ $t("total") }} {{ $t("currency") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(r, ri) in reports">
                <template v-if="smrSort">
                  <template v-for="(a, ai) in r.activities">
                    <tr
                      v-for="(w, i) in r.workers"
                      :key="`r-${r._id}-reportIndex-${ri}-a-${a._id}-${i}-actIndex-${ai}-wo-${w._id}`"
                      @click="goToReport(r._id)"
                      :class="{
                        'tr-invalid': r.isInvalid,
                        'additional-row': a.isAdditional,
                      }"
                    >
                      <td>
                        <span class="no-wrap"
                          >{{ r.date | formatDate }} г.</span
                        >
                      </td>
                      <td>{{ r.createdBy.name }}</td>
                      <td>{{ r.company.companyName }}</td>
                      <td>{{ r.object.objectName }}</td>
                      <td>{{ r.part.partName }}</td>
                      <td>
                        <span v-if="a.isAdditional">⚡</span>
                        {{ a.name }}
                      </td>
                      <td class="ma-cell-name">
                        <div class="name-wrapp">
                          <template v-if="!exportingExcel">
                            <span
                              class="tms tms--blue tms--role"
                              v-if="w.permissions"
                              >y</span
                            >
                            <span class="tms tms--blue tms--role" v-else
                              >0</span
                            >
                          </template>
                          <span>{{ w.name }}</span>
                        </div>
                      </td>
                      <td>{{ a.note }}</td>
                      <td>{{ a.unit }}</td>
                      <td>{{ a.price }}</td>
                      <td>
                        <p class="hours-status" :class="smrStatus(a)">
                          {{ a.totalUsed || 0 }}
                        </p>
                      </td>
                      <td>{{ a.plannedHours }}</td>
                      <td
                        v-if="
                          getUser.permissions.isSuperAdmin ||
                          getUser.permissions.isAdmin
                        "
                      >
                        <p v-if="w.users">
                          {{
                            (
                              (+a.quantity / w.totalWorkers) *
                              +a.price *
                              w.users.length
                            ).toFixed(2)
                          }}
                        </p>
                        <p v-else>
                          {{
                            ((+a.quantity / w.totalWorkers) * +a.price).toFixed(
                              2
                            )
                          }}
                        </p>
                      </td>
                    </tr>
                  </template>
                </template>
                <template v-for="(w, wi) in r.workers" v-else>
                  <tr
                    v-for="(a, i) in r.activities"
                    :key="`r-${r._id}-reportIndex-${ri}-a-${a._id}-${i}-wo-${w._id}-workerIndex-${wi}`"
                    @click="goToReport(r._id)"
                    :class="{
                      'tr-invalid': r.isInvalid,
                      'additional-row': a.isAdditional,
                    }"
                  >
                    <td>
                      <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                    </td>
                    <td>{{ r.createdBy.name }}</td>
                    <td>{{ r.company.companyName }}</td>
                    <td>{{ r.object.objectName }}</td>
                    <td>{{ r.part.partName }}</td>
                    <td>
                      <span v-if="a.isAdditional">⚡</span>
                      {{ a.name }}
                    </td>
                    <td class="ma-cell-name">
                      <div class="name-wrapp">
                        <template v-if="!exportingExcel">
                          <span
                            class="tms tms--blue tms--role"
                            v-if="w.permissions"
                            >y</span
                          >
                          <span class="tms tms--blue tms--role" v-else>0</span>
                        </template>
                        <span>{{ w.name }}</span>
                      </div>
                    </td>
                    <td>{{ a.note }}</td>
                    <td>{{ a.unit }}</td>
                    <td>{{ a.price }}</td>
                    <td>
                      <p class="hours-status" :class="smrStatus(a)">
                        {{ a.totalUsed || 0 }}
                      </p>
                    </td>
                    <td>{{ a.plannedHours }}</td>
                    <td
                      v-if="
                        getUser.permissions.isSuperAdmin ||
                        getUser.permissions.isAdmin
                      "
                    >
                      <p v-if="w.users">
                        {{
                          (
                            (+a.quantity / w.totalWorkers) *
                            +a.price *
                            w.users.length
                          ).toFixed(2)
                        }}
                      </p>
                      <p v-else>
                        {{
                          ((+a.quantity / w.totalWorkers) * +a.price).toFixed(2)
                        }}
                      </p>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-if="isInquiryMade && !totalActivityQuantity">
                <td colspan="13" class="td-center">
                  {{ $t("inquiry-no-activities") }}
                </td>
              </tr>
              <tr
                class="sum-row"
                v-if="
                  getUser.permissions.isSuperAdmin ||
                  getUser.permissions.isAdmin
                "
              >
                <td colspan="6">
                  {{ $t("total-hours-used") }}:
                  {{ totalActivitiesUsedHours.toFixed(2) }}
                </td>
                <td colspan="3">
                  {{ $t("total-planned-used") }}:
                  {{ totalActivitiesPlannedHours.toFixed(2) }}
                </td>
                <td colspan="4">
                  {{ $t("total") }}: {{ totalActivities.toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- SUMMARY -->
        <div class="table-wrapper" v-show="activeTab === 3">
          <table class="table summary-table" ref="summary">
            <thead>
              <tr>
                <th></th>
                <template v-if="isGroupByCompany">
                  <th></th>
                  <th></th>
                  <th>
                    <div class="table-sort-wrapper">
                      {{ $t("activity") }} /
                      {{ $t("material") }}
                      <section
                        class="sorting"
                        :class="{
                          'sorting--active': isSortingActive('materials.name'),
                        }"
                      >
                        <span
                          class="tms"
                          @click="selectSorting('materials.name', 1)"
                          :class="{
                            'tms--active': isSortingActive('materials.name', 1),
                          }"
                          >2</span
                        >
                        <span
                          class="tms"
                          @click="selectSorting('materials.name', -1)"
                          :class="{
                            'tms--active': isSortingActive(
                              'materials.name',
                              -1
                            ),
                          }"
                          >3</span
                        >
                      </section>
                    </div>
                  </th>
                  <th></th>
                </template>
                <template v-else>
                  <th>
                    <div class="table-sort-wrapper">
                      {{ $t("date") | capitalize }}
                      <section
                        class="sorting"
                        :class="{ 'sorting--active': isSortingActive('date') }"
                      >
                        <span
                          class="tms"
                          @click="selectSorting('date', 1)"
                          :class="{ 'tms--active': isSortingActive('date', 1) }"
                          >2</span
                        >
                        <span
                          class="tms"
                          @click="selectSorting('date', -1)"
                          :class="{
                            'tms--active': isSortingActive('date', -1),
                          }"
                          >3</span
                        >
                      </section>
                    </div>
                  </th>
                  <th>
                    <div class="table-sort-wrapper">
                      {{ $t("reporter") }}
                      <section
                        class="sorting"
                        :class="{
                          'sorting--active': isSortingActive('createdBy.name'),
                        }"
                      >
                        <span
                          class="tms"
                          @click="selectSorting('createdBy.name', 1)"
                          :class="{
                            'tms--active': isSortingActive('createdBy.name', 1),
                          }"
                          >2</span
                        >
                        <span
                          class="tms"
                          @click="selectSorting('createdBy.name', -1)"
                          :class="{
                            'tms--active': isSortingActive(
                              'createdBy.name',
                              -1
                            ),
                          }"
                          >3</span
                        >
                      </section>
                    </div>
                  </th>
                </template>
                <template v-if="!isGroupByCompany">
                  <th>
                    <div class="table-sort-wrapper">
                      {{ $t("company") }}
                      <section
                        class="sorting"
                        :class="{
                          'sorting--active': isSortingActive(
                            'company.companyName'
                          ),
                        }"
                      >
                        <span
                          class="tms"
                          @click="selectSorting('company.companyName', 1)"
                          :class="{
                            'tms--active': isSortingActive(
                              'company.companyName',
                              1
                            ),
                          }"
                          >2</span
                        >
                        <span
                          class="tms"
                          @click="selectSorting('company.companyName', -1)"
                          :class="{
                            'tms--active': isSortingActive(
                              'company.companyName',
                              -1
                            ),
                          }"
                          >3</span
                        >
                      </section>
                    </div>
                  </th>
                  <th>
                    <div class="table-sort-wrapper">
                      {{ $t("site") }}
                      <section
                        class="sorting"
                        :class="{
                          'sorting--active':
                            isSortingActive('object.objectName'),
                        }"
                      >
                        <span
                          class="tms"
                          @click="selectSorting('object.objectName', 1)"
                          :class="{
                            'tms--active': isSortingActive(
                              'object.objectName',
                              1
                            ),
                          }"
                          >2</span
                        >
                        <span
                          class="tms"
                          @click="selectSorting('object.objectName', -1)"
                          :class="{
                            'tms--active': isSortingActive(
                              'object.objectName',
                              -1
                            ),
                          }"
                          >3</span
                        >
                      </section>
                    </div>
                  </th>
                  <th>
                    <div class="table-sort-wrapper">
                      {{ $t("part") }}
                      <section
                        class="sorting"
                        :class="{
                          'sorting--active': isSortingActive('part.partName'),
                        }"
                      >
                        <span
                          class="tms"
                          @click="selectSorting('part.partName', 1)"
                          :class="{
                            'tms--active': isSortingActive('part.partName', 1),
                          }"
                          >2</span
                        >
                        <span
                          class="tms"
                          @click="selectSorting('part.partName', -1)"
                          :class="{
                            'tms--active': isSortingActive('part.partName', -1),
                          }"
                          >3</span
                        >
                      </section>
                    </div>
                  </th>
                </template>
                <th v-if="!isGroupByCompany">
                  <div class="table-sort-wrapper">
                    {{ $t("activity") }} /
                    {{ $t("material") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('materials.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('materials.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('materials.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('materials.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('materials.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>{{ $t("metric-unit") }}</th>
                <th v-if="isGroupByCompany">{{ $t("price-one") }}</th>
                <th v-if="!isGroupByCompany">{{ $t("price-one") }}</th>
                <th>{{ $t("real") }}</th>
                <th>{{ $t("planned") }}</th>
                <th
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin
                  "
                >
                  {{ $t("total-price-report") }}
                </th>
              </tr>
            </thead>
            <thead>
              <tr>
                <td :colspan="isGroupByCompany ? 10 : 12">
                  <section class="summary-options">
                    <div class="toggle">
                      <p
                        @click="isGroupByCompany = true"
                        :class="{ 'p--active': isGroupByCompany }"
                      >
                        ГРУПИРАНЕ ПО ФИРМА
                      </p>

                      <div class="switch-container switch-container--reversed">
                        <label class="switch">
                          <input type="checkbox" v-model="isGroupByCompany" />
                          <span class="slider"></span>
                        </label>
                      </div>

                      <p
                        @click="isGroupByCompany = false"
                        :class="{ 'p--active': !isGroupByCompany }"
                      >
                        ГРУПИРАНЕ ПО СМР
                      </p>
                    </div>
                    <div class="toggle toggle--right">
                      <Checkbox
                        :radio="true"
                        :value="showOnlyWithReport === undefined"
                        @input="selectOnlyWithReportValue(undefined)"
                        label="ПОКАЖИ ВСИЧКИ СМР"
                      />
                      <Checkbox
                        :radio="true"
                        :value="showOnlyWithReport === true"
                        @input="selectOnlyWithReportValue(true)"
                        label="ПОКАЖИ СМР САМО С ОТЧЕТ"
                      />
                      <Checkbox
                        :radio="true"
                        :value="showOnlyWithReport === false"
                        @input="selectOnlyWithReportValue(false)"
                        label="ПОКАЖИ СМР САМО БЕЗ ОТЧЕТ"
                      />
                    </div>
                  </section>
                </td>
              </tr>
            </thead>
            <!-- SUMMARY BY COMPANY -->
            <template v-if="isGroupByCompany">
              <tbody v-for="sc of summaryCompanies" :key="sc.name">
                <tr @click="toggleShow(sc)" class="company-row">
                  <td colspan="7">
                    <div
                      class="summary-name"
                      :class="{ 'summary-name-active': sc.showContent }"
                    >
                      <span class="tms2">{{
                        `${sc.showContent ? "]" : "^"}`
                      }}</span>
                      <p>{{ sc.companyName }}</p>
                    </div>
                  </td>
                  <td>
                    <!-- {{ sc.company.totalUsedCompany.toFixed(2) }} -->
                  </td>
                  <td>
                    <!-- {{ sc.company.totalPlannedCompany.toFixed(2) }} -->
                  </td>
                  <td>
                    <!-- {{ sc.company.totalPriceCompany.toFixed(2) }} -->
                  </td>
                </tr>
                <template v-if="sc.showContent">
                  <template v-for="(object, oi) of sc.objects">
                    <tr
                      :key="object._id"
                      class="summary-tr summary-tr--object"
                      @click="toggleShow(object)"
                    >
                      <td class="inv td--invisible"></td>
                      <td colspan="6">
                        <div
                          class="summary-name"
                          :class="{ 'summary-name-active': object.showContent }"
                        >
                          <span class="tms2">{{
                            `${object.showContent ? "]" : "^"}`
                          }}</span>
                          <p>{{ object.objectName }}</p>
                        </div>
                      </td>
                      <td>
                        <!-- {{ object.totalUsedObject.toFixed(2) }} -->
                      </td>
                      <td>
                        <!-- {{ object.totalPlannedObject.toFixed(2) }} -->
                      </td>
                      <td>
                        <!-- {{ object.totalPriceObject.toFixed(2) }} -->
                      </td>
                    </tr>
                    <template v-if="object.showContent && object.parts.length">
                      <template v-for="(part, pi) of object.parts">
                        <tr
                          :key="part._id"
                          class="summary-tr summary-tr--part"
                          @click="toggleShow(part)"
                        >
                          <td
                            :class="{
                              'inv inv--horizontal':
                                oi !== sc.objects.length - 1,
                            }"
                          ></td>
                          <td class="inv td--invisible"></td>
                          <td colspan="5">{{ part.partName }}</td>
                          <td>
                            <!-- {{ part.totalUsedPart.toFixed(2) }} -->
                          </td>
                          <td>
                            <!-- {{ part.totalPlannedPart.toFixed(2) }} -->
                          </td>
                          <td>
                            <!-- {{ part.totalPricePart.toFixed(2) }} -->
                          </td>
                        </tr>
                        <template v-if="part.showContent">
                          <tr
                            class="tr--split tr--split__company"
                            :key="`part-${part._id}-materials`"
                            v-if="part.materials.length"
                          >
                            <td
                              class="td--invisible"
                              :class="{
                                'inv inv--horizontal':
                                  oi !== sc.objects.length - 1,
                              }"
                            ></td>
                            <td
                              class="td--invisible"
                              :class="{
                                'inv inv--horizontal':
                                  pi !== object.parts.length - 1,
                              }"
                            ></td>
                            <td colspan="7" class="td-center">1. Материали</td>
                            <td class="td-center">
                              {{ part.totalPriceMats.toFixed(2) }}
                            </td>
                          </tr>
                          <template v-for="mat of part.materials">
                            <tr
                              :key="`part-${part._id}-mat-${mat._id}`"
                              class="tr-summary"
                            >
                              <td
                                class="td--invisible"
                                :class="{
                                  'inv inv--horizontal':
                                    oi !== sc.objects.length - 1,
                                }"
                              ></td>
                              <td
                                class="td--invisible"
                                :class="{
                                  'inv inv--horizontal':
                                    pi !== object.parts.length - 1,
                                }"
                              ></td>
                              <td></td>
                              <td colspan="2" class="td--max-width">
                                <span v-if="mat.isAdditional">⚡</span>
                                {{ mat.name }}
                              </td>
                              <!-- <td class="td--max-width">{{sc.company.companyName}}</td>
                  <td class="td--max-width">{{object.objectName}}</td>
                  <td class="td--max-width">{{part.partName}}</td> -->
                              <td>{{ mat.unit }}</td>
                              <td>{{ mat.price }}</td>
                              <td>{{ mat.totalUsed }}</td>
                              <td>-</td>
                              <td>{{ mat.totalPrice }}</td>
                            </tr>
                          </template>
                          <tr
                            class="tr--split tr--split__company"
                            :key="`part-${part._id}-activities`"
                            v-if="part.activities.length"
                          >
                            <td
                              class="td--invisible"
                              :class="{
                                'inv inv--horizontal':
                                  oi !== sc.objects.length - 1,
                              }"
                            ></td>
                            <td
                              class="td--invisible"
                              :class="{
                                'inv inv--horizontal':
                                  pi !== object.parts.length - 1,
                              }"
                            ></td>
                            <td colspan="7" class="td-center">2. СМР</td>
                            <td class="td-center">
                              {{ part.totalPriceActs.toFixed(2) }}
                            </td>
                          </tr>
                          <template v-for="act of part.activities">
                            <tr
                              :key="`part-${part._id}-act-${act._id}`"
                              class="tr-summary"
                            >
                              <td
                                class="td--invisible"
                                :class="{
                                  'inv inv--horizontal':
                                    oi !== sc.objects.length - 1,
                                }"
                              ></td>
                              <td
                                class="td--invisible"
                                :class="{
                                  'inv inv--horizontal':
                                    pi !== object.parts.length - 1,
                                }"
                              ></td>
                              <td></td>
                              <td colspan="2" class="td--max-width">
                                <span v-if="act.isAdditional">⚡</span>
                                {{ act.name }}
                              </td>
                              <!-- <td class="td--max-width">{{sc.company.companyName}}</td>
                  <td class="td--max-width">{{object.objectName}}</td>
                  <td class="td--max-width">{{part.partName}}</td> -->
                              <td>{{ act.unit }}</td>
                              <td>{{ act.price }}</td>
                              <td>
                                <p class="hours-status" :class="smrStatus(act)">
                                  {{ act.totalUsed || 0 }}
                                </p>
                              </td>
                              <td>{{ act.plannedHours }}</td>
                              <td>{{ act.totalPrice }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </tbody>
            </template>
            <!-- SUMMARY BY COMPANY -->
            <!-- SUMMARY BY SMR -->
            <template v-else>
              <tbody>
                <tr class="tr--split">
                  <td colspan="12" class="td-center">1. Материали</td>
                </tr>
              </tbody>
              <tbody v-for="s of summary.mats" :key="s.name">
                <tr @click="toggleShowReports(s)" class="tr-summary">
                  <td colspan="7">
                    <div
                      class="summary-name"
                      :class="{ 'summary-name-active': s.showReports }"
                    >
                      <span class="tms2">{{
                        `${s.showReports ? "]" : "^"}`
                      }}</span>
                      <p>{{ s.name }}</p>
                    </div>
                  </td>
                  <td>{{ s.unit }}</td>
                  <td>{{ s.price }}</td>
                  <td colspan="2">{{ s.quantity }}</td>
                  <td>{{ s.totalSum }}</td>
                </tr>
                <template v-if="s.showReports">
                  <tr
                    v-for="(r, i) of s.reports"
                    :key="`report-${r._id}-${i}`"
                    class="summary-tr"
                    @click="goToReport(r._id)"
                  >
                    <td>
                      <div class="inv"></div>
                    </td>
                    <td>{{ r.date | formatDate }} г.</td>
                    <td>{{ r.createdBy.name }}</td>
                    <td>{{ r.company.companyName }}</td>
                    <td>{{ r.object.objectName }}</td>
                    <td>{{ r.part.partName }}</td>
                    <td>
                      <span v-if="r.materials[0].isAdditional">⚡</span>
                      {{ s.name }}
                    </td>
                    <td>{{ r.materials[0].unit }}</td>
                    <td>{{ s.price }}</td>
                    <td>{{ r.materials[0].quantity }}</td>
                    <td></td>
                    <td>
                      {{
                        (
                          r.materials[0].quantity * r.materials[0].price
                        ).toFixed(2)
                      }}
                    </td>
                  </tr>
                </template>
              </tbody>
              <tbody>
                <tr class="tr--split">
                  <td colspan="12" class="td-center">2. СМР</td>
                </tr>
              </tbody>
              <tbody v-for="s of summary.acts" :key="s.name">
                <tr @click="toggleShowReports(s)" class="tr-summary">
                  <td colspan="7">
                    <div
                      class="summary-name"
                      :class="{ 'summary-name-active': s.showReports }"
                    >
                      <span class="tms2">{{
                        `${s.showReports ? "]" : "^"}`
                      }}</span>
                      <p>{{ s.name }}</p>
                    </div>
                  </td>
                  <td>{{ s.unit }}</td>
                  <td>{{ s.price }}</td>
                  <td :class="smrStatus(s.reports[0].activities[0])">
                    <p
                      class="hours-status"
                      :class="smrStatus(s.reports[0].activities[0])"
                    >
                      {{ s.reports[0].activities[0].totalUsed || 0 }}
                    </p>
                  </td>
                  <td>{{ s.plannedHours }}</td>
                  <td>{{ s.totalSum }}</td>
                </tr>
                <template v-if="s.showReports">
                  <tr
                    v-for="(r, ri) of s.reports"
                    :key="`report-${ri}`"
                    class="summary-tr"
                    @click="goToReport(r._id)"
                  >
                    <td>
                      <div class="inv"></div>
                    </td>
                    <td>{{ r.date | formatDate }} г.</td>
                    <td>{{ r.createdBy.name }}</td>
                    <td>{{ r.company.companyName }}</td>
                    <td>{{ r.object.objectName }}</td>
                    <td>{{ r.part.partName }}</td>
                    <td>
                      <span v-if="r.activities[0].isAdditional">⚡</span>
                      {{ s.name }}
                    </td>
                    <td>{{ r.activities[0].unit }}</td>
                    <td>{{ s.price }}</td>
                    <td>{{ r.activities[0].quantity }}</td>
                    <td></td>
                    <td>
                      {{
                        (
                          r.activities[0].quantity *
                          Number(r.activities[0].price)
                        ).toFixed(2)
                      }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
            <!-- SUMMARY BY SMR -->
          </table>
        </div>
        <!-- WORKER GROUPS -->
        <div class="table-wrapper">
          <table class="table" ref="WorkersGroup" v-show="activeTab === 4">
            <thead>
              <tr>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("date") | capitalize }}
                    <section
                      class="sorting"
                      :class="{ 'sorting--active': isSortingActive('date') }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('date', 1)"
                        :class="{ 'tms--active': isSortingActive('date', 1) }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('date', -1)"
                        :class="{ 'tms--active': isSortingActive('date', -1) }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("reporter") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('createdBy.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('createdBy.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('createdBy.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("company") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive(
                          'company.companyName'
                        ),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('company.companyName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'company.companyName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("site") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('object.objectName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', 1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            1
                          ),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('object.objectName', -1)"
                        :class="{
                          'tms--active': isSortingActive(
                            'object.objectName',
                            -1
                          ),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <div class="table-sort-wrapper">
                    {{ $t("part") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('part.partName'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', 1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('part.partName', -1)"
                        :class="{
                          'tms--active': isSortingActive('part.partName', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>
                  <!-- {{ $t('smr-type') }} -->
                  <div class="table-sort-wrapper">
                    {{ $t("smr-type") }}
                    <section
                      class="sorting"
                      :class="{
                        'sorting--active': isSortingActive('materials.name'),
                      }"
                    >
                      <span
                        class="tms"
                        @click="selectSorting('materials.name', 1)"
                        :class="{
                          'tms--active': isSortingActive('materials.name', 1),
                        }"
                        >2</span
                      >
                      <span
                        class="tms"
                        @click="selectSorting('materials.name', -1)"
                        :class="{
                          'tms--active': isSortingActive('materials.name', -1),
                        }"
                        >3</span
                      >
                    </section>
                  </div>
                </th>
                <th>{{ $t("smr-name") }}</th>
                <th>{{ $t("worker") }}</th>
                <th>{{ $t("quantity") }}</th>
                <th>{{ $t("metric-unit") }}</th>
                <th>{{ $t("price-one") }}</th>
                <th
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin
                  "
                >
                  {{ $t("total") }} {{ $t("currency") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(r, ri) in reports">
                <template v-if="r.isWorkersGroup.length">
                  <template v-for="w in r.isWorkersGroup">
                    <tr
                      v-for="(m, i) in r.materials"
                      :key="`r-${r._id}-ma-${m._id}-${i}-wo-${w._id}`"
                      @click="goToReport(r._id)"
                      :class="{
                        'tr-invalid': r.isInvalid,
                        'additional-row': m.isAdditional,
                      }"
                    >
                      <td>
                        <span class="no-wrap"
                          >{{ r.date | formatDate }} г.</span
                        >
                      </td>
                      <td>{{ r.createdBy.name }}</td>
                      <td>{{ r.company.companyName }}</td>
                      <td>{{ r.object.objectName }}</td>
                      <td>{{ r.part.partName }}</td>
                      <td>
                        <span v-if="m.isAdditional">⚡</span>
                        {{ m.name }}
                      </td>
                      <td>Материал</td>
                      <td>
                        <div class="name-wrapp">
                          <span
                            class="tms tms--brown tms--role"
                            v-if="!exportingExcel"
                            >1</span
                          >
                          <span>{{ w.name }}</span>
                        </div>
                      </td>
                      <td>{{ (m.quantity / w.totalWorkers).toFixed(2) }}</td>
                      <td>{{ m.unit }}</td>
                      <td>{{ m.price }}</td>
                      <td
                        v-if="
                          getUser.permissions.isSuperAdmin ||
                          getUser.permissions.isAdmin
                        "
                      >
                        {{
                          (+m.price * (m.quantity / w.totalWorkers)).toFixed(2)
                        }}
                      </td>
                    </tr>
                    <tr
                      v-for="(m, i) in r.activities"
                      :key="`r-${r._id}-reportIndex-${ri}-ac-${m._id}-${i}-wo-${w._id}`"
                      @click="goToReport(r._id)"
                      :class="{
                        'tr-invalid': r.isInvalid,
                        'additional-row': m.isAdditional,
                      }"
                    >
                      <td>
                        <span class="no-wrap"
                          >{{ r.date | formatDate }} г.</span
                        >
                      </td>
                      <td>{{ r.createdBy.name }}</td>
                      <td>{{ r.company.companyName }}</td>
                      <td>{{ r.object.objectName }}</td>
                      <td>{{ r.part.partName }}</td>
                      <td>
                        <span v-if="m.isAdditional">⚡</span>
                        {{ m.name }}
                      </td>
                      <td>СМР</td>
                      <td>
                        <div class="name-wrapp">
                          <span
                            class="tms tms--brown tms--role"
                            v-if="!exportingExcel"
                            >1</span
                          >
                          <span>{{ w.name }}</span>
                        </div>
                      </td>
                      <td>{{ (+m.quantity / w.totalWorkers).toFixed(2) }}</td>
                      <td>{{ m.unit }}</td>
                      <td>{{ m.price }}</td>
                      <td
                        v-if="
                          getUser.permissions.isSuperAdmin ||
                          getUser.permissions.isAdmin
                        "
                      >
                        {{
                          (+m.price * (m.quantity / w.totalWorkers)).toFixed(2)
                        }}
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
              <tr v-if="isInquiryMade && !totalWorkersGroups">
                <td colspan="12" class="td-center">
                  {{ $t("inquiry-no-group-workers-for-smr") }}
                </td>
              </tr>
              <tr
                class="sum-row"
                v-if="
                  getUser.permissions.isSuperAdmin ||
                  getUser.permissions.isAdmin
                "
              >
                <td colspan="10">{{ $t("total") }}:</td>
                <td colspan="2">
                  {{ totalWorkers.toFixed(2) }} {{ $t("currency") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ZARABOTKI -->
        <div class="table-wrapper">
          <div class="switch-wrapper" v-show="activeTab === 5">
            <label
              class="switch-label"
              :class="{ 'switch-label-active': !showByReport }"
              @click="selectSwitch(false), (showByReport = false)"
              >Общи заработки</label
            >
            <div class="switch-container">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="showByReport"
                  @input="selectSwitch(!showByReport)"
                />
                <span class="slider"></span>
              </label>
            </div>
            <label
              class="switch-label"
              :class="{ 'switch-label-active': showByReport }"
              @click="selectSwitch(true), (showByReport = true)"
              >Заработки по отчети</label
            >
          </div>

          <table
            class="table"
            ref="workersEarningsSum"
            v-show="activeTab === 5 && !showByReport"
          >
            <thead>
              <tr>
                <th>Период</th>
                <th class="print-hide">Работник</th>
                <!-- <th>Общо планирано време (ч.)</th> -->
                <th>Общо изработено време (ч.)</th>
                <th>Общо заработки (лв.)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(user, i) in periodWorkers"
                :key="`user-${i}`"
                v-show="
                  $route.query.worker
                    ? user._id === $route.query.worker ||
                      user.worker === $route.query.worker
                    : true
                "
              >
                <td>
                  {{ inquiry.fromDate | formatDate }} -
                  {{ inquiry.toDate | formatDate }}
                </td>
                <td class="print-hide">{{ user.name }}</td>
                <!-- <td>
                  {{
                    user.totalPlannedDaysLoading
                      ? "зареждане..."
                      : user.totalPlannedDays || "-"
                  }}
                </td> -->
                <td>{{ user.totalTimeWorked }}</td>
                <td>{{ user.totalZarabotki }}</td>
              </tr>

              <tr v-if="isInquiryMade && !totalWorkerItems">
                <td
                  :colspan="getUser.permissions.isSuperAdmin ? 13 : 9"
                  class="td-center"
                >
                  Няма добавени работници за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" v-if="getUser.permissions.isSuperAdmin">
                <td :colspan="getUser.permissions.isSuperAdmin ? 13 : 9">
                  Общо изразходено време:
                  <span>{{ totalZarabotkiWorkers.total }} ч.</span
                  >&nbsp;&nbsp;&nbsp;Общо заработки:
                  <span
                    >{{ totalZarabotkiWorkers.earnings.toFixed(2) }} лв.</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table"
            ref="workersEarningsReports"
            v-show="activeTab === 5 && showByReport"
          >
            <thead>
              <tr>
                <th>Дата</th>
                <th class="center">Дата на създаване</th>
                <th class="print-hide">Работник</th>
                <th>Фирма</th>
                <th>Обект</th>
                <th>Част</th>
                <th class="print-big-td">Дейност</th>
                <th class="center">Изработено количество</th>
                <th class="center">М.ед.</th>
                <template v-if="getUser.permissions.isSuperAdmin">
                  <th
                    class="print-hide center"
                    style="background-color: #a2bdf3"
                  >
                    Стойност на заработката
                  </th>
                  <th
                    class="print-hide center"
                    style="background-color: #a2bdf3"
                  >
                    М.ед.
                  </th>
                  <th class="print-hide center">Коефициент на работника</th>
                  <th class="print-hide center">Заработка/лв</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="report in reports">
                <template v-for="(a, ai) in report.activities">
                  <template v-for="workerType in ['workers', 'isWorkersGroup']">
                    <tr
                      v-for="(worker, wi) in report[workerType]"
                      :key="`report-${report._id}-${ai}-worker-${worker._id}-${wi}-${workerType}`"
                      @click="goToReport(report._id)"
                      :class="{ 'tr-invalid': report.isInvalid }"
                    >
                      <td>
                        <span class="no-wrap"
                          >{{ report.date | formatDate }} г.</span
                        >
                      </td>
                      <td>
                        <span class="no-wrap"
                          >{{ report.createdAt | formatDate }} г.</span
                        >
                      </td>
                      <td class="print-hide">{{ worker.name }}</td>
                      <td>{{ report.company.companyName }}</td>
                      <td>{{ report.object.objectName }}</td>
                      <td>{{ report.part.partName }}</td>
                      <td class="print-big-td">{{ a.name }}</td>
                      <td class="center">
                        {{ (a.quantity / report.repWorkersCount).toFixed(2) }}
                        <!-- {{ (a.quantity || 0) }} -->
                      </td>
                      <td class="center">
                        {{ a.unit }}
                      </td>
                      <template v-if="getUser.permissions.isSuperAdmin">
                        <td
                          class="print-hide center"
                          style="background-color: #dde4f1"
                        >
                          {{ a.earnings || "-" }}
                        </td>
                        <td
                          class="print-hide center"
                          style="background-color: #dde4f1"
                        >
                          лв/{{ a.unit }}
                        </td>
                        <td class="print-hide center">
                          {{ worker.coefficient }}
                        </td>
                        <td class="print-hide center">
                          {{
                            (
                              (a.quantity / report.repWorkersCount) *
                              (worker.coefficient || 0) *
                              (a.earnings || 0)
                            ).toFixed(2)
                          }}
                        </td>
                      </template>
                    </tr>
                  </template>
                </template>
              </template>
              <tr v-if="isInquiryMade && !totalWorkerItems">
                <td
                  :colspan="getUser.permissions.isSuperAdmin ? 13 : 9"
                  class="td-center"
                >
                  Няма добавени работници за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" v-if="getUser.permissions.isSuperAdmin">
                <td :colspan="getUser.permissions.isSuperAdmin ? 13 : 9">
                  Общо изразходено време:
                  <span>{{ totalZarabotkiWorkers.total }} ч.</span
                  >&nbsp;&nbsp;&nbsp;Общо заработки:
                  <span
                    >{{ totalZarabotkiWorkers.earnings.toFixed(2) }} лв.</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- MOBILE BUTTONS -->
    <footer class="modal-footer mobile" v-if="reports.length" ref="footer">
      <div class="btns mobile">
        <!-- UP -->
        <span
          class="new-content-data-item-toggle-circle mobile top"
          @click="scrollToTop()"
        >
          <span class="tms">f</span>
        </span>
        <!-- NEW Inquiry -->
        <span
          class="new-content-data-item-toggle-circle mobile"
          @click="resetInquiry()"
        >
          <span class="tms">L</span>
        </span>
        <!-- EXPORT IN EXCEL -->
        <span
          class="new-content-data-item-toggle-circle mobile excel"
          @click="exportToExcelFile()"
        >
          <span class="tms">E</span>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import TheFilters from "../components/shared/TheFilters.vue";
import hours from "./mixins/hours.js";
import Checkbox from "./shared/Checkbox.vue";
// import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import XLSX from "xlsx-js-style";
import { mapGetters } from "vuex";
export default {
  components: {
    // Datepicker,
    Checkbox,
    TheFilters,
  },
  mixins: [hours],
  data() {
    return {
      // Vars for select v-model
      company: "",
      // project: '',
      object: "",
      part: "",
      reporter: "",
      worker: "",
      // Scroll checker
      isScrolled: false,
      showByReport: false,
      periodWorkers: [],
      totalActivityItems: 0,
      totalWorkerItems: 0,
      bg: bg,
      formatedFromDate: null,
      formatedToDate: null,
      activeTab: 0,
      datePeriod: "current",
      // SEARCH
      // searchProjects: '',
      searchAllUsers: "",
      selectedUsersType: {},
      usersTypes: [
        { name: this.$t("users-vas"), value: "users-vas" },
        { name: this.$t("reporters"), value: "isReporter" },
        { name: this.$t("users-groups"), value: "groups" },
        { name: this.$t("users-workers-groups"), value: "isWorkerGroup" },
        { name: this.$t("select-all"), value: "all" },
      ],
      hoursStatusStyleOrange: {
        fill: { fgColor: { rgb: "E28800" } },
        font: { bold: true, color: { rgb: "ffffff" } },
      },
      hoursStatusStyleGreen: {
        fill: { fgColor: { rgb: "00a86b" } },
        font: { bold: true, color: { rgb: "ffffff" } },
      },
      hoursStatusStyleRed: {
        fill: { fgColor: { rgb: "c84630" } },
        font: { bold: true, color: { rgb: "ffffff" } },
      },
      searchUsersTypes: "",
      companies: [],
      objects: [],
      parts: [],
      reporters: [],
      allUsers: [],
      reports: [],
      summary: [],
      summaryCompanies: [],
      periodWorkersPromises: [],
      isGroupByCompany: true,
      showOnlyWithReport: undefined,
      mdm: [],
      totalMaterials: 0,
      totalActivities: 0,
      totalActivitiesUsedHours: 0,
      totalActivitiesPlannedHours: 0,
      totalMechanizations: 0,
      totalZarabotkiWorkers: 0,
      totalWorkers: 0,
      totalMaterialQuantity: 0,
      totalActivityQuantity: 0,
      totalMechanizationQuantity: 0,
      totalWorkersGroups: 0,
      isInquiryMade: false,
      queryObject: {},
      tableFilters: {},
      smrSort: undefined,
      activeObjects: true,
      exportingExcel: false,
      inquiry: {
        fromDate: "",
        toDate: "",
        company: {
          _id: "",
          companyName: "",
        },
        // project: {
        //   _id: '',
        //   projectName: ''
        // },
        object: {
          _id: "",
          objectName: "",
        },
        part: {
          _id: "",
          partName: "",
        },
        reporter: {
          _id: "",
          name: "",
        },
        worker: {
          _id: "",
          name: "",
        },
        isInvalid: false,
        priceStatus: null,
        search: "",
      },
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      "getLoading",
      // ...
    ]),
  },
  watch: {
    "inquiry.fromDate"(to, from) {
      // eslint-disable-next-line
      if (!!from) {
        this.resetReports();
      }
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      this.queryObject.fromDate = this.inquiry.fromDate.toISOString();
      
      this.formatedFromDate = format(new Date(this.inquiry.fromDate), 'dd/MM/yyyy');
    },
    "inquiry.toDate"(to, from) {
      // eslint-disable-next-line
      if (!!from) {
        this.resetReports();
      }
      this.inquiry.toDate.setHours(23, 59, 59, 999);
      this.queryObject.toDate = this.inquiry.toDate.toISOString();
      this.formatedToDate = format(new Date(this.inquiry.toDate), 'dd/MM/yyyy');
    },
    isInquiryMade(to) {
      console.log(`i = ${to}`);
    },
  },
  methods: {
    focusInput(id, dropdownNum) {
      let input = document.getElementById(id);
      if (this.openedDropdown[dropdownNum]) {
        input.blur();
      } else {
        input.focus();
      }
    },
    // TODO: try to move this in getTotals
    calculateData(array) {
      const totals = {
        materials: 0,
        activities: 0,
      };
      let sum = {
        normal: 0,
        overtime: 0,
        holiday: 0,
        total: 0,
        normalTotal: 0,
        overtimeTotal: 0,
        holidayTotal: 0,
        earnings: 0,
      };
      this.totalActivityItems = 0;
      this.totalWorkerItems = 0;

      if (array.length) {
        array.forEach((r) => {
          for (let x of ["materials", "activities"]) {
            if (r[x]) {
              // eslint-disable-next-line
              for (let y of r[x]) {
                if (x === "activities") this.totalActivityItems++;
                totals[x] += +x.quantity * +x.price;
              }
            }
          }

          this.$set(r, "calculated", { normal: 0, overtime: 0, holiday: 0 });
          for (let workerType of ["workers", "isWorkersGroup"]) {
            if (r[workerType]) {
              r[workerType].forEach((w) => {
                this.totalWorkerItems++;
                const calculated = this.calculateHours(
                  r.date,
                  w.startHour,
                  w.endHour
                );

                sum.normal += calculated.normal;
                sum.holiday += calculated.holiday;
                sum.overtime += calculated.overtime;
                sum.total += calculated.total;
                sum.normalTotal +=
                  calculated.normal *
                  (w.wage ? (w.wage / 22 / 8).toFixed(2) : 0);
                sum.overtimeTotal +=
                  calculated.overtime *
                  ((w.wage ? (w.wage / 22 / 8).toFixed(2) : 0) * 1);
                sum.holidayTotal +=
                  calculated.holiday *
                  ((w.wage ? (w.wage / 22 / 8).toFixed(2) : 0) * 1);

                this.$set(w, "calculated", calculated);

                this.$set(
                  r.calculated,
                  "holiday",
                  r.calculated.holiday + calculated.holiday
                );
                this.$set(
                  r.calculated,
                  "normal",
                  r.calculated.normal + calculated.normal
                );
                this.$set(
                  r.calculated,
                  "overtime",
                  r.calculated.overtime + calculated.overtime
                );
              });
            }
          }
        });

        // this.totalMaterials = totals.materials;
        // this.totalActivities = totals.activities;
        this.totalZarabotkiWorkers = sum;
        this.getWorkersProducedQuantity(array);
      }
    },
    async getAllZarabotkiData(wo, array) {
      let sum = { totalTime: 0, totalZarabotki: 0 };

      let url = `${process.env.VUE_APP_BASE_URI}/planning/inquiry`;

      url += `/${this.inquiry.fromDate.toISOString()}`;
      url += `/${this.inquiry.toDate.toISOString()}`;
      // url += `/${wo.group}`;
      if (wo.group) {
        url += `?workerGroup=${wo.group}`;
      }
      this.$set(wo, "totalPlannedDaysLoading", true);

      this.periodWorkersPromises.push(
        await new Promise((resolve) => {
          this.$http
            .get(url)
            .then((response) => {
              if (response.data.length) {
                this.$set(wo, "totalPlannedDays", response.data.length * 8);
              }
              this.$set(wo, "totalPlannedDaysLoading", false);
              resolve();
            })
            .catch((err) => console.log(err));
          if (array.length) {
            console.log(array)
            array.forEach((r) => {
              for (let a of r.activities) {
                for (let workerType of ["workers", "isWorkersGroup"]) {
                  for (let w of r[workerType]) {
                    if (w._id === wo._id) {
                      sum.totalZarabotki +=
                        (a.quantity / r.repWorkersCount) *
                        (w.coefficient || 0) *
                        (a.earnings || 0);

                      const calculated = this.calculateHours(
                        r.date,
                        w.startHour,
                        w.endHour
                      );
                      sum.totalTime += calculated.total / r.activities.length;
                    }
                  }
                }
              }
              // for (let w of r.workers) {
              //   if (w._id === wo._id) {
              //     const calculated = this.calculateHours(
              //       r.date,
              //       w.startHour,
              //       w.endHour
              //     );
              //     sum.totalTime += calculated.total;
              //   }
              // }
            });
          }

          this.$set(wo, "totalTimeWorked", sum.totalTime);
          this.$set(wo, "totalZarabotki", sum.totalZarabotki.toFixed(2));
        })
      );
    },
    getWorkersProducedQuantity(array) {
      let total = 0;
      for (let r of array) {
        const w = r.repWorkersCount;
        if (w) {
          for (let tag of ["materials", "activities"]) {
            if (r[tag].length) {
              for (let a of r[tag]) {
                const pq = a.quantity / w;
                this.$set(a, "producedQuantity", pq);

                for (let workerType of ["workers", "isWorkersGroup"]) {
                  for (let wo of r[workerType]) {
                    if (
                      this.$route.query.worker
                        ? wo._id === this.$route.query.worker ||
                          wo.worker === this.$route.query.worker
                        : true
                    ) {
                      this.periodWorkers.push(wo);
                    }

                    total +=
                      (pq || 0) * (wo.coefficient || 0) * (a.earnings || 0);
                  }
                }
              }
            }
          }
        }

        this.$set(this.totalZarabotkiWorkers, "earnings", total);
      }
      this.periodWorkers = [
        ...new Map(this.periodWorkers.map((item) => [item._id, item])).values(),
      ];
      if (!this.showUnreported) {
        this.periodWorkersPromises = [];
        this.periodWorkers.map((x) => this.getAllZarabotkiData(x, array));

        if (this.periodWorkersPromises.length) {
          Promise.all(this.periodWorkersPromises)
            .then(() => {
              this.close(true);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    selectSwitch(type) {
      if (type) this.queryObject.workersTableType = type;
      else delete this.queryObject.workersTableType;

      this.$router.push({ query: this.queryObject }).catch(() => {});
    },
    isSortingActive(f, v) {
      if (!v && this.tableFilters[f]) return true;
      else if (v && this.tableFilters[f] && this.tableFilters[f] === v)
        return true;
      else return false;
    },
    selectOnlyWithReportValue(v) {
      this.showOnlyWithReport = v;
      this.getSummaryCompanies();
    },
    selectSorting(t, v, smrSort) {
      this.tableFilters = {};
      if (smrSort !== undefined) this.smrSort = smrSort;
      else {
        this.tableFilters[t] = v;
        this.smrSort = undefined;
      }
      this.getInquiry();
    },
    resetSelectedSorting() {
      this.tableFilters = {};
      this.getInquiry();
    },
    toggleShowReports(s) {
      this.$set(s, "showReports", !s.showReports);
    },
    toggleShow(s) {
      this.$set(s, "showContent", !s.showContent);
      if (!s.showContent) this.hideContents(s);
    },
    hideContents(t) {
      if (t.company) {
        this.$set(t, "showContent", false);

        t.company.objects.map((ob) => {
          this.$set(ob, "showContent", false);
          ob.parts.map((pa) => {
            this.$set(pa, "showContent", false);
          });
        });
      } else if (t.objectName) {
        this.$set(t, "showContent", false);

        t.parts.map((pa) => {
          this.$set(pa, "showContent", false);
        });
      }
    },
    // showSmrOrMat(smr) {
    //   if (this.showOnlyWithReport === true) return smr.totalUsed > 0;
    //   if (this.showOnlyWithReport === false)
    //     return smr.totalUsed === 0 || !smr.totalUsed;
    //   else return true;
    // },
    print() {
      window.print();
    },
    changeDatePeriod(p) {
      this.datePeriod = p;
      if (p === "current") {
        this.setDates(0, -1);
      } else if (p === "previous") {
        this.setDates(1, 0);
      } else if (p === "half") {
        this.setDates(6, -1);
      } else if (p === "year") {
        this.setDates(12, -1);
      } else if (p === "all") {
        this.setDates(12000, -12000);
      }
      this.queryObject.period = p;
      this.$router.push({ query: this.queryObject }).catch((err) => err);
    },
    selectPriceStatus(p) {
      this.resetReports();
      if (p === this.inquiry.priceStatus) {
        this.inquiry.priceStatus = null;
      } else {
        this.inquiry.priceStatus = p;
      }
      this.queryObject.status = p;
      this.$router.push({ query: this.queryObject }).catch((err) => err);
    },
    formatSummary(byCompany) {
      let formatSummary = [];

      let companyStyle = {
        fill: { fgColor: { rgb: "3e74cf" } },
        font: { color: { rgb: "ffffff" } },
      };
      let objectStyle = {
        fill: { fgColor: { rgb: "917474" } },
        font: { color: { rgb: "ffffff" } },
      };
      let partStyle = {
        fill: { fgColor: { rgb: "557d75" } },
        font: { color: { rgb: "ffffff" } },
      };
      let splitStyle = {
        fill: { fgColor: { rgb: "515A7D" } },
        font: { color: { rgb: "ffffff" } },
      };
      let sStyle = {
        fill: { fgColor: { rgb: "c8dcf4" } },
        font: { bold: true },
      };

      let boldStyle = { font: { bold: true } };

      if (byCompany) {
        formatSummary.push([
          {
            v: `${this.$t("activity")} / ${this.$t("material")}`,
            s: boldStyle,
          },
          // { v: this.$t("company"), s: boldStyle },
          // { v: this.$t("site"), s: boldStyle },
          // { v: this.$t("part"), s: boldStyle },
          { v: this.$t("unit"), s: boldStyle },
          { v: this.$t("price-one"), s: boldStyle },
          { v: this.$t("real"), s: boldStyle },
          { v: this.$t("planned"), s: boldStyle },
          { v: this.$t("total-price-report"), s: boldStyle },
        ]);

        for (let sc of this.summaryCompanies) {
          formatSummary.push([
            { v: sc.companyName, s: companyStyle },
            { v: "", s: companyStyle },
            { v: "", s: companyStyle },
            { v: this.$t("real"), s: companyStyle },
            { v: this.$t("planned"), s: companyStyle },
            { v: this.$t("total-price-report"), s: companyStyle },
          ]);

          for (let object of sc.objects) {
            formatSummary.push([
              { v: object.objectName, s: objectStyle },
              { v: "", s: objectStyle },
              { v: "", s: objectStyle },
              { v: this.$t("real"), s: objectStyle },
              { v: this.$t("planned"), s: objectStyle },
              { v: this.$t("total-price-report"), s: objectStyle },
            ]);
            for (let part of object.parts) {
              formatSummary.push([
                { v: part.partName, s: partStyle },
                { v: "", s: partStyle },
                { v: "", s: partStyle },
                { v: this.$t("real"), s: partStyle },
                { v: this.$t("planned"), s: partStyle },
                { v: this.$t("total-price-report"), s: partStyle },
              ]);

              for (let tag of ["materials", "activities"]) {
                if (part[tag] && part[tag].length) {
                  formatSummary.push([
                    { v: "", s: splitStyle },
                    { v: "", s: splitStyle },
                    {
                      v: `${tag === "materials" ? "1. Материал" : "2. СМР"}`,
                      s: splitStyle,
                    },
                    { v: "", s: splitStyle },
                    { v: "", s: splitStyle },
                    { v: "", s: splitStyle },
                  ]);
                }

                for (let t of part[tag]) {
                  formatSummary.push([
                    { v: `${t.isAdditional ? "⚡" : ""} ${t.name}` },
                    // { v: sc.company.companyName },
                    // { v: object.objectName },
                    // { v: part.partName },
                    { v: t.unit },
                    { v: t.price },
                    {
                      v: t.totalUsed,
                      s: tag !== "materials" ? this.smrStatus(t, true) : "",
                    },
                    { v: tag === "materials" ? "" : t.plannedHours },
                    { v: t.totalPrice },
                  ]);
                }
              }
            }
          }
        }
      } else {
        for (let type of ["mats", "acts"]) {
          let md = type === "mats" ? "materials" : "activities";

          formatSummary.push([
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            {
              v: `${type === "mats" ? "1. Материал" : "2. СМР"}`,
              s: splitStyle,
            },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
            { v: "", s: splitStyle },
          ]);
          formatSummary.push([
            { v: "Дата", s: boldStyle },
            { v: "Отчетник", s: boldStyle },
            { v: "Фирма", s: boldStyle },
            { v: "Обект", s: boldStyle },
            { v: "Част", s: boldStyle },
            { v: "СМР / Материал", s: boldStyle },
            { v: "Мерна единица", s: boldStyle },
            { v: "Количество", s: boldStyle },
            { v: "Ед. Цена", s: boldStyle },
            { v: "Изпълнено", s: boldStyle },
            { v: "Планирано", s: boldStyle },
            { v: "Обща цена в лв", s: boldStyle },
          ]);

          for (let m of this.summary[type]) {
            let tU = m.reports[0][md][0].totalUsed;
            let pH = m.reports[0][md][0].plannedHours;

            formatSummary.push([
              { v: m.name, s: sStyle },
              { v: "", s: sStyle },
              { v: "", s: sStyle },
              { v: "", s: sStyle },
              { v: "", s: sStyle },
              { v: "", s: sStyle },
              { v: m.unit, s: sStyle },
              { v: m.quantity, s: sStyle },
              { v: m.price, s: sStyle },
              {
                v: type === "mats" ? "" : tU || 0,
                s:
                  type === "mats"
                    ? sStyle
                    : this.smrStatus(m.reports[0][md][0], true),
              },
              { v: type === "mats" ? "" : pH || 0, s: sStyle },
              { v: (m.price * m.quantity).toFixed(2), s: sStyle },
            ]);

            for (let r of m.reports) {
              formatSummary.push([
                { v: this.$options.filters.formatDate(r.date) },
                { v: r.createdBy.name },
                { v: r.company.companyName },
                { v: r.object.objectName },
                { v: r.part.partName },
                { v: r[md][0].name },
                { v: r[md][0].unit },
                { v: r[md][0].quantity },
                { v: r[md][0].price },
                { v: "" },
                { v: "" },
                { v: (r[md][0].quantity * r[md][0].price).toFixed(2) },
              ]);
            }
          }
        }
      }
      return formatSummary;
    },
    toggleIconsDisplayExcel() {
      return new Promise((resolve) => {
        this.exportingExcel = true;
        setTimeout(() => {
          resolve();
        }, 100);
      });
    },
    async exportToExcelFile() {
      const wscols = [
        { wpx: 150 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
      ];

      await this.toggleIconsDisplayExcel(true);

      const config = { dateNF: "dd/mm/yyyy" };
      // Convert Table to Worksheet

      // if (!this.inquiry.worker._id) {
      const reportsWorksheet = XLSX.utils.table_to_sheet(
        this.$refs["reportsTable"],
        config
      );
      const materialsWorksheet = XLSX.utils.table_to_sheet(
        this.$refs["materials"],
        config
      );
      const activitiesWorksheet = XLSX.utils.table_to_sheet(
        this.$refs["activities"],
        config
      );
      const workersWorksheet = XLSX.utils.table_to_sheet(
        this.$refs["WorkersGroup"],
        config
      );
      const summariessWorksheet = XLSX.utils.json_to_sheet(
        [...this.formatSummary()],
        { skipHeader: true }
      );
      const summariessCompanyWorksheet = XLSX.utils.json_to_sheet(
        [...this.formatSummary(true)],
        { skipHeader: true }
      );
      const workersEarningsSumWorksheet = XLSX.utils.table_to_sheet(
        this.$refs["workersEarningsSum"],
        config
      );
      const workersEarningsReportsWorksheet = XLSX.utils.table_to_sheet(
        this.$refs["workersEarningsReports"],
        config
      );
      // Define New Workbook
      const new_workbook = XLSX.utils.book_new();

      reportsWorksheet["!cols"] = wscols;
      materialsWorksheet["!cols"] = wscols;
      activitiesWorksheet["!cols"] = wscols;
      summariessWorksheet["!cols"] = wscols;
      summariessCompanyWorksheet["!cols"] = wscols;
      workersWorksheet["!cols"] = wscols;
      workersEarningsSumWorksheet["!cols"] = wscols;
      workersEarningsReportsWorksheet["!cols"] = wscols;

      // Append Worksheet
      XLSX.utils.book_append_sheet(
        new_workbook,
        reportsWorksheet,
        this.$t("reports")
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        materialsWorksheet,
        this.$t("Materials")
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        activitiesWorksheet,
        this.$t("activities")
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        workersWorksheet,
        this.$t("WorkersGroup")
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        summariessWorksheet,
        "Обобщено по СМР"
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        summariessCompanyWorksheet,
        "Обобщено по фирма"
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        workersEarningsSumWorksheet,
        "Общи заработки"
      );
      XLSX.utils.book_append_sheet(
        new_workbook,
        workersEarningsReportsWorksheet,
        "Заработки по отчети"
      );
      // Save File
      XLSX.writeFile(
        new_workbook,
        `${this.$t("inquiry")}-${this.formatedFromDate}-${
          this.formatedToDate
        }.xlsx`
      );
      // } else {
      //   const workersWorksheet = XLSX.utils.table_to_sheet(
      //     this.$refs['workers'],
      //     config
      //   );
      //   // Define New Workbook
      //   const new_workbook = XLSX.utils.book_new();

      //   workersWorksheet['!cols'] = wscols;

      //   // Append Worksheet
      //   XLSX.utils.book_append_sheet(
      //     new_workbook,
      //     workersWorksheet,
      //     this.$t('Workers')
      //   );
      //   // Save File

      //   XLSX.writeFile(
      //     new_workbook,
      //     `${this.$t('inquiry')}-${this.$t('for')}-${
      //       this.inquiry.worker.name
      //     }-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
      //   );
      // }
      this.exportingExcel = false;
    },
    selectTab(num) {
      this.activeTab = num;
      this.queryObject.tab = this.activeTab;
      this.$router.push({ query: this.queryObject }).catch((err) => err);
      this.resetSelectedSorting();
    },
    smrStatus(a, excel) {
      if (Number(a.totalUsed) === Number(a.plannedHours))
        return excel ? this.hoursStatusStyleGreen : "hours-status--green";
      if (Number(a.totalUsed) > Number(a.plannedHours))
        return excel ? this.hoursStatusStyleOrange : "hours-status--orange";
      else return excel ? this.hoursStatusStyleRed : "hours-status--red";
    },
    // RESETS
    resetInquiry() {
      // this.resetUsersType();
      this.reports = [];
      this.periodWorkers = [];
      this.isInquiryMade = false;
      // this.resetSelectedCompany();
      // if (
      //   this.getUser.permissions.isSuperAdmin ||
      //   this.getUser.permissions.isAdmin
      // ) {
      //   this.resetSelectedReporter();
      //   this.resetSelectedUser();
      // }
      // this.selectPriceStatus(null);
      // this.changeDatePeriod("current");
      // this.activeObjects = true;
      // this.inquiry.isInvalid = false;
      // this.inquiry.search = "";
    },
    resetReports() {
      this.reports = [];
      this.periodWorkers = [];
      this.isInquiryMade = false;
    },
    // SELECTS
    selectCompany(c) {
      this.resetReports();
      this.inquiry.company = c;
      this.queryObject.company = c._id;
      this.queryObject.companyName = c.companyName;
    },
    // selectProject(p) {
    //   this.resetReports();
    //   this.inquiry.project = p;
    //   this.queryObject.project = p._id;
    //   this.queryObject.projectName = p.projectName;
    // },
    selectObject(o) {
      this.resetReports();
      this.inquiry.object = o;
      this.queryObject.object = o._id;
      this.queryObject.objectName = o.objectName;
    },
    selectPart(p) {
      this.resetReports();
      this.inquiry.part = p;
      this.queryObject.part = p._id;
      this.queryObject.partName = p.partName;
    },
    selectReporter(r) {
      this.resetReports();
      this.inquiry.reporter = r;
      this.queryObject.reporter = r._id;
      this.queryObject.reporterName = r.name;
    },
    resetUsersType() {
      this.selectUsersType({ name: this.$t("select-all") }, true);
    },
    selectUsersType(t, reset, index) {
      if (this.activeTab === 5 && index && index !== 0 && index !== 3) {
        return this.$snotify.error(
          `Само ${this.$t("users-vas")} и ${this.$t(
            "users-workers-groups"
          )} са възможни като опция при избран таб "Заработки" `
        );
      }

      if (t.name === this.$t("select-all")) {
        // select / deselect all
        if (this.selectedUsersType[t.name] && !reset) {
          this.usersTypes.forEach((x) => delete this.selectedUsersType[x.name]);
        } else {
          this.usersTypes.forEach(
            (x) => (this.selectedUsersType[x.name] = x.value)
          );
        }
      } else {
        if (this.selectedUsersType[t.name])
          delete this.selectedUsersType[t.name];
        else this.selectedUsersType[t.name] = t.value;
      }
      this.getAllUsers();
    },
    setDates(from, to) {
      const date = new Date();
      // set first day of previous month
      this.inquiry.fromDate = new Date(
        date.getFullYear(),
        date.getMonth() - from,
        1
      );
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.inquiry.toDate = new Date(
        date.getFullYear(),
        date.getMonth() + to * -1,
        0
      );
      this.inquiry.toDate.setHours(23, 59, 59, 999);
    },
    getTotals() {
      this.totalMaterialQuantity = 0;
      this.totalActivityQuantity = 0;
      this.totalMechanizationQuantity = 0;
      this.totalWorkersGroups = 0;
      let isWorkersGroupCount = [];

      let materialsSum = 0;
      let activitiesSum = 0;
      let activitiesUsedHours = 0;
      let activitiesPlannedHours = 0;
      let mechanizationsSum = 0;
      let workersSum = 0;

      if (this.reports.length) {
        this.reports.forEach((r) => {
          if (r.isWorkersGroup) {
            r.isWorkersGroup.forEach((m) => {
              if (!isWorkersGroupCount.includes(m._id))
                isWorkersGroupCount.push(m._id);

              for (let tag of ["materials", "activities"]) {
                if (r[tag]) {
                  r[tag].forEach((x) => {
                    workersSum += (+x.quantity / +r.repWorkersCount) * +x.price;
                  });
                }
              }
            });
          }
          if (r.workers) {
            r.workers.forEach((w) => {
              for (let tag of ["materials", "activities"]) {
                if (r[tag]) {
                  r[tag].forEach((x) => {
                    if (tag === "materials") {
                      this.totalMaterialQuantity++;
                      if (w.users)
                        materialsSum +=
                          (+x.quantity / w.totalWorkers) *
                          +x.price *
                          w.users.length;
                      else
                        materialsSum +=
                          (+x.quantity / w.totalWorkers) * +x.price;
                    }

                    if (tag === "activities") {
                      this.totalActivityQuantity++;
                      activitiesUsedHours += Number(
                        x.totalUsed / w.totalWorkers
                      );
                      activitiesPlannedHours += Number(
                        x.plannedHours / w.totalWorkers
                      );
                      if (w.users)
                        activitiesSum +=
                          (+x.quantity / w.totalWorkers) *
                          +x.price *
                          w.users.length;
                      else
                        activitiesSum +=
                          (+x.quantity / w.totalWorkers) * +x.price;
                    }
                  });
                }
              }
            });
          }
        });
      }
      this.totalWorkersGroups = isWorkersGroupCount.length;
      this.totalWorkers = workersSum;
      this.totalMaterials = materialsSum;
      this.totalActivities = activitiesSum;
      this.totalActivitiesUsedHours = activitiesUsedHours;
      this.totalActivitiesPlannedHours = activitiesPlannedHours;
      this.totalMechanizations = mechanizationsSum;
      this.$store.dispatch("stopLoading");
      this.isInquiryMade = true;
    },
    // REQUESTS
    getCompanies() {
      let url = "";
      if (this.getUser.permissions.isAdmin) {
        url = `${process.env.VUE_APP_BASE_URI}/company/${
          this.activeObjects ? "active" : "inactive"
        }`;
      } else if (this.getUser.permissions.isReporter) {
        url = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${this.getUser._id}`;
      } else {
        this.$snotify.error(this.$t("no-permissions"));
      }

      return this.$http
        .get(url)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => console.log(error));
    },
    // getProjects() {
    //   this.projects = [];
    //   if (this.inquiry.company._id) {
    //     let url = '';

    //     if (this.getUser.permissions.isAdmin) {
    //       url = `${process.env.VUE_APP_BASE_URI}/company/project-names/${
    //         this.inquiry.company._id
    //       }?active=${this.activeObjects ? 'true' : 'false'}`;
    //     } else if (this.getUser.permissions.isReporter) {
    //       url = `${process.env.VUE_APP_BASE_URI}/company/reporters/projects/${this.inquiry.company._id}/${this.getUser._id}`;
    //     } else {
    //       this.$snotify.error(this.$t('no-permissions'));
    //     }

    //     return this.$http
    //       .get(url)
    //       .then(response => {
    //         this.projects = response.data;
    //       })
    //       .catch(error => console.log(error.response));
    //   }
    // },
    getObjects() {
      this.objects = [];
      if (this.inquiry.company._id) {
        let url = "";

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/object-names/${
            this.inquiry.company._id
          }?active=${this.activeObjects ? "true" : "false"}`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.inquiry.company._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error(this.$t("no-permissions"));
        }

        return this.$http
          .get(url)
          .then((response) => {
            this.objects = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    getParts() {
      this.parts = [];
      if (this.inquiry.object._id) {
        let url = "";

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/part-names/${
            this.inquiry.company._id
          }/${this.inquiry.object._id}?active=${
            this.activeObjects ? "true" : "false"
          }`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/parts/${this.inquiry.company._id}/${this.inquiry.object._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error(this.$t("no-permissions"));
        }

        return this.$http
          .get(url)
          .then((response) => {
            this.parts = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    getReporters() {
      this.reporters = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/reporters`)
        .then((response) => {
          this.reporters = response.data;
        });
    },
    async getAllUsers() {
      let filterBy = Object.values(this.selectedUsersType);

      let users = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/auth/users?noReporters=true`
      );
      let reporters = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/auth/users/reporters`
      );
      let workerGroups = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/group?workerGroups=true`
      );
      let groups = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/group?notEmpty=true`
      );

      this.allUsers = [];
      if (filterBy.includes("users-vas")) this.allUsers.push(...users.data);
      if (filterBy.includes("isReporter"))
        this.allUsers.push(...reporters.data);
      if (filterBy.includes("groups")) this.allUsers.push(...groups.data);
      if (filterBy.includes("isWorkerGroup"))
        this.allUsers.push(...workerGroups.data);
      this.allUsers = this.allUsers.sort((a, b) =>
        b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 1
      );
    },
    // if there are queries, load the existing parameters and assign them to the empty queryObject
    // TODO: refactor
    loadQueries(query) {
      if (Object.keys(query).length) {
        if (query.fromDate) {
          this.inquiry.fromDate = new Date(query.fromDate);
          this.queryObject.fromDate = query.fromDate;
        }
        if (query.toDate) {
          this.inquiry.toDate = new Date(query.toDate);
          this.queryObject.toDate = query.toDate;
        }
        if (query.company) {
          this.inquiry.company._id = query.company;
          this.queryObject.company = query.company;
        }
        if (query.companyName) {
          this.inquiry.company.companyName = query.companyName;
          this.queryObject.companyName = query.companyName;
        }
        // if (query.project) {
        //   this.inquiry.project._id = query.project;
        //   this.queryObject.project = query.project;
        // }
        // if (query.projectName) {
        //   this.inquiry.project.projectName = query.projectName;
        //   this.queryObject.projectName = query.projectName;
        // }
        if (query.object) {
          this.inquiry.object._id = query.object;
          this.queryObject.object = query.object;
        }
        if (query.objectName) {
          this.inquiry.object.objectName = query.objectName;
          this.queryObject.objectName = query.objectName;
        }
        if (query.part) {
          this.inquiry.part._id = query.part;
          this.queryObject.part = query.part;
        }
        if (query.partName) {
          this.inquiry.part.partName = query.partName;
          this.queryObject.partName = query.partName;
        }
        if (query.reporter) {
          this.inquiry.reporter._id = query.reporter;
          this.queryObject.reporter = query.reporter;
        }
        if (query.reporterName) {
          this.inquiry.reporter.name = query.reporterName;
          this.queryObject.reporterName = query.reporterName;
        }
        if (query.worker) {
          this.inquiry.worker._id = query.worker;
          this.queryObject.worker = query.worker;
        }
        if (query.workerName) {
          this.inquiry.worker.name = query.workerName;
          this.queryObject.workerName = query.workerName;
        }
        if (query.isInvalid) {
          const isInvalid = query.isInvalid == "true" ? true : false;
          this.inquiry.isInvalid = isInvalid;
          this.queryObject.isInvalid = isInvalid;
        }
        if (query.active) {
          const active = query.active == "true" ? true : false;
          this.activeObjects = active;
          this.queryObject.active = active;
        }
        if (query.tab) {
          this.selectTab(+query.tab);
        }
        if (query.period) {
          this.datePeriod = query.period;
          this.queryObject.period = query.period;
        }
        if (query.status) {
          this.selectPriceStatus(+query.status);
        }
        if (query.search) {
          this.inquiry.search = query.search;
        }

        this.getInquiry();
      }
    },
    getUrl() {
      // this.inquiry.search = this.inquiry.search.replace('/', '');

      let url = `${process.env.VUE_APP_BASE_URI}/report/inquiry`;
      url += `/${this.inquiry.company._id ? this.inquiry.company._id : 0}`;
      // url += `/${this.inquiry.project._id ? this.inquiry.project._id : 0}`;
      url += `/${this.inquiry.object._id ? this.inquiry.object._id : 0}`;
      url += `/${this.inquiry.part._id ? this.inquiry.part._id : 0}`;
      url += `/${this.inquiry.reporter._id ? this.inquiry.reporter._id : 0}`;
      url += `/${this.inquiry.worker._id ? this.inquiry.worker._id : 0}`;
      url += `/${this.inquiry.fromDate.toISOString()}`;
      url += `/${this.inquiry.toDate.toISOString()}`;
      url += `/${this.inquiry.isInvalid}`;
      url += `/${this.activeObjects}`;
      url += `/${this.inquiry.priceStatus}`;
      url += `/${
        this.inquiry.search ? encodeURIComponent(this.inquiry.search) : null
      }`;
      return url;
    },
    async getSummary() {
      this.summary = [];

      this.$http.get(this.getUrl() + `?summary=true`).then((res) => {
        // TEMP SORTING
        for (let m of res.data.mats) {
          m.reports.forEach((r) => {
            r.materials = r.materials.filter((x) => x.name === m.name);
          });
        }
        for (let m of res.data.acts) {
          m.reports.forEach((r) => {
            r.activities = r.activities.filter((x) => x.name === m.name);
          });
        }
        this.summary = res.data;
      });
    },
    getSummaryCompanies() {
      this.summaryCompanies = [];
      let url = `${process.env.VUE_APP_BASE_URI}/company/inquirySummary`;
      url += `?dateFrom=${this.inquiry.fromDate.toISOString()}`;
      url += `&dateTo=${this.inquiry.toDate.toISOString()}`;

      if (this.inquiry.company._id) {
        url += `&companyId=${this.inquiry.company._id}`;
      }
      if (this.inquiry.object._id) {
        url += `&objectId=${this.inquiry.object._id}`;
      }
      if (this.inquiry.part._id) {
        url += `&partId=${this.inquiry.part._id}`;
      }

      if (Object.keys(this.tableFilters).length) {
        url += `&sortBy=${Object.entries(this.tableFilters)[0]}`;
      }

      if (this.showOnlyWithReport !== undefined) {
        url += `&showOnlyWithReport=${this.showOnlyWithReport}`;
      }

      this.$http.get(url).then((res) => {
        this.summaryCompanies = res.data;
      });
    },
    // group workers by brigades
    // setReportWorkers(r, groups) {
    setReportWorkers(r) {
      let newWorkers = [];
      let usersInGroup = [];
      // groups.map((g) => {
      //   let filterByGroup = r.workers.filter((w) => {
      //     if (w.group && w.group === g._id) return w._id
      //   }).map((t) => t._id);

      //   if (filterByGroup.length === g.users.length && g.users.length) {
      //     g.totalWorkers = r.repWorkersCount
      //     newWorkers.push(g), usersInGroup.push(g.users.map((u) => u._id))
      //   }

      // });
      if (r.workers.length)
        r.workers.filter((u) => {
          u.totalWorkers = r.repWorkersCount;

          // if users is not in full group then add him
          if (usersInGroup.length && !usersInGroup[0].includes(u._id)) {
            newWorkers.push(u);
          }
        });
      if (r.isWorkersGroup.length)
        r.isWorkersGroup.filter((u) => {
          u.totalWorkers = r.repWorkersCount;
        });
      if (newWorkers.length) this.$set(r, "workers", newWorkers);
      else this.$set(r, "workers", r.workers);

      this.getTotals();
    },
    checkPeriod() {
      const longPeriods = ["half", "year", "all"];

      if (longPeriods.includes(this.datePeriod)) {
        if (confirm(this.$t("inquiry-period-warning"))) {
          this.getInquiry();
        }
      } else {
        this.getInquiry();
      }
    },
    async getInquiry() {
      this.getSummary();
      this.getSummaryCompanies();
      let groups = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/group`
      );

      this.$store.dispatch("startLoading");
      if (this.inquiry.search) {
        this.queryObject.search = this.inquiry.search;
      }
      this.$router.push({ query: this.queryObject }).catch((err) => err);
      this.reports = [];
      this.periodWorkers = [];

      let url = this.getUrl();
      if (Object.keys(this.tableFilters).length) {
        url += `?sortBy=${Object.entries(this.tableFilters)[0]}`;
      }

      this.$http.get(url).then((response) => {
        this.reports = response.data;

        if (this.reports.length) {
          this.reports.map((r, i) => {
            let counter = 1;
            for (let j = i + 1; j < this.reports.length; j++) {
              if (
                this.reports[j]._id === r._id &&
                !this.reports[j].alreadyMerged
              ) {
                counter++;
                this.$set(this.reports[j], "alreadyMerged", true);
              } else break;
            }
            if (counter > 1) this.$set(r, "mergeRows", counter);
            this.setReportWorkers(r, groups.data);
          });

          this.calculateData(this.reports);
        } else {
          this.$store.dispatch("stopLoading");
          this.isInquiryMade = true;
        }

        if (!this.$route.query.tab) {
          this.activeTab = 0;
        }

        // Scroll to inquiry
        this.isScrolled = true;
      });
    },
    // Scroll to the inquiry after click of the button "Направи справка"
    scrollToInquiry() {
      if (
        this.$refs["reports"] != undefined &&
        this.reports.length &&
        this.isScrolled
      ) {
        this.$refs["reports"].scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
        this.isScrolled = false;
      } else if (
        this.$refs["no-reports"] != undefined &&
        !this.reports.length &&
        this.isScrolled
      ) {
        this.$refs["no-reports"].scrollIntoView({ behavior: "smooth" });
        this.isScrolled = false;
      }
    },
    scrollToTop() {
      this.$refs["top"].scrollIntoView({ behavior: "smooth" });
    },
    goToReport(id) {
      this.$router.push(`/reports/edit/${id}?back=true`);
    },
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    // this.setDates(0, -1);
    this.loadQueries(this.$route.query);
    this.resetUsersType();

    if (
      !this.getUser.permissions.isAdmin &&
      this.getUser.permissions.isReporter
    ) {
      this.selectReporter({
        name: this.getUser.name,
        _id: this.getUser._id,
      });
    }

    this.$eventBus.$on("export", () => {
      this.$nextTick(() => {
        this.exportToExcelFile();
      });
    });
    this.$eventBus.$on("makeInquiryFromSpeechRecognition", (period) => {
      this.changeDatePeriod(period);
      this.getInquiry();
    });
  },
  updated() {
    this.scrollToInquiry();
  },
  destroyed() {
    this.$eventBus.$off("export");
    this.$eventBus.$off("makeInquiryFromSpeechRecognition");
  },
};
</script>

<style lang="scss" scoped>
.inquiry {
  padding: 10px 40px;
}
// .inquiry-header {
//   align-items: center;
//   display: flex;
//   height: 36px;
//   justify-content: space-between;
// }
// .inquiry-header-controlls {
//   align-items: center;
//   display: flex;
// }
// .inquiry-pre-datepicker-text {
//   color: #373737;
//   display: inline-block;
//   font-size: 11px;
//   font-weight: 700;
//   margin-right: 20px;
// }
// .inquiry-datepicker {
//   border-radius: 4px;
//   display: flex;
//   position: relative;
//   width: 330px;
//   padding: 10px 0;
// }
// .inquiry-datepicker .new-input-wrapper {
//   background-color: #104d8033;
//   margin: 0;
//   width: 50%;
// }
// .inquiry-datepicker .new-input-wrapper:first-child {
//   border-bottom-left-radius: 4px;
//   border-top-left-radius: 4px;
// }
// .inquiry-datepicker .new-input-wrapper:nth-child(2) {
//   border-bottom-right-radius: 4px;
//   border-top-right-radius: 4px;
// }
// .inquiry-datepicker .new-input {
//   background-color: transparent;
//   margin: 0;
// }
// .inquiry-datepicker .new-input input {
//   background-color: transparent;
//   border: 1px solid #104d8033;
//   height: 36px;
//   cursor: pointer;
// }
// .inquiry-datepicker .new-input input:focus {
//   background-color: #fff;
//   border: 1px solid #104d8033;
// }
/* .inquiry-datepicker .datepicker-dropdown { */
/* background-color: #ccd1e3; */
/* } */
// .inquiry-header-controlls .btns {
//   align-items: center;
// }
// .inquiry-filters {
//   background-color: #104d8033;
//   border-radius: 4px;
//   margin-top: 10px;
//   padding: 10px 25px 15px;
// }
// .inquiry-filters-inputs {
//   align-items: flex-end;
//   display: flex;
// }
// .inquiry-filters-inputs .new-input-wrapper:last-child {
//   margin-right: 0;
// }
// .inquiry-filters-btns {
//   align-items: center;
//   display: flex;
//   justify-content: space-between;
//   margin-top: 5px;
//   position: relative;
// }
// .inquiry-filters-btns .checkboxes {
//   display: flex;
// }
// .checkboxes-wrapper {
//   display: flex;
//   gap: 15px;
//   left: 50%;
//   position: absolute;
//   top: 50%;
//   transform: translateX(-50%) translateY(-50%);
// }
// .inquiry-filters-btns .btn {
//   margin: 0;
// }
// .inquiry-filters-btns .btn-print,
// .inquiry-filters-btns .btn-excel {
//   margin-right: 10px;
// }
/* CONTENT */
.reports-tabs {
  display: flex;
  font-weight: 700;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: -1px;
  position: relative;
}
.switch-wrapper {
  align-items: center;
  display: flex;
  gap: 10px;
  padding: 10px 0 0;
}
.switch-wrapper .switch-container .switch {
  margin: initial;
}
.switch-wrapper .switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-wrapper .switch-label-active {
  opacity: 1;
  text-decoration: underline;
}

.reports-tab {
  align-items: center;
  background-color: #104d8033;
  border: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  font-weight: 700;
  display: flex;
  height: 45px;
  justify-content: center;
  margin: 0 3px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: 25%;
}
.reports-tab span {
  text-transform: capitalize;
}
.reports-tab span:first-child {
  margin-right: 2px;
}
.reports-tab:first-child {
  margin-left: 0;
}
.reports-tab:last-child {
  margin-right: 0;
}
.reports-tab:hover {
  background-color: #ffffff;
  border: 1px solid #ccd1e3;
  border-bottom: 1px solid #fff;
}
.reports-tab-active {
  background-color: #fff;
  border: 1px solid #ccd1e3;
  border-bottom: 1px solid #fff;
}
.reports-tab-active:hover {
  background-color: #fff;
}
.reports-content {
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #ccd1e3;
  padding: 0 10px;
}
.reports-content .table tbody tr {
  background-color: #104d8033;
}
.reports-content .table tbody td {
  padding: 10px;
}
.reports-content .table .td-company-name {
  position: relative;
  padding: 0 20px;
}
.reports-content .table tbody .tr-invalid {
  background-color: #fff8f8;
}
.reports-content .table tbody tr:hover {
  background-color: #104d8033;
}
.reports-content .table tbody .sum-row {
  background-color: transparent;
  font-size: 18px;
  font-weight: 700;
  text-align: right;
}
.reports-content .table tbody .additional-row {
  background-color: #f1f4c0;
}
.reports-content .table tbody .company-row {
  background-color: #ebf0f8;
  position: relative;
  z-index: 2;
}
.no-reports {
  /* background-color: #fff; */
  /* border-radius: 4px; */
  padding: 20px;
  text-align: center;
  width: 100%;
}
.td-center {
  text-align: center;
}
.test {
  display: flex;
}
.table-wrapper {
  overflow: auto;
}
// .date-toggles,
// .flag-toggles {
//   align-items: center;
//   display: flex;
// }
// .date-toggle,
// .flag-toggle {
//   align-items: center;
//   background-color: #ffffff;
//   border: 1px solid #104d8033;
//   border-radius: 4px;
//   color: #0058bc;
//   cursor: pointer;
//   font-size: 24px;
//   display: inline-flex;
//   height: 36px;
//   justify-content: center;
//   margin-left: 10px;
//   -webkit-transition: all 0.3s;
//   -moz-transition: all 0.3s;
//   -ms-transition: all 0.3s;
//   -o-transition: all 0.3s;
//   transition: all 0.3s;
//   width: 36px;
// }
// .flag-toggles p {
//   margin-right: 10px;
// }
// .flag-toggle img {
//   width: 24px;
// }
// .date-toggle:hover,
// .flag-toggle:hover {
//   border-color: rgba(77, 77, 77, 0.2);
// }
// .date-toggle-active,
// .flag-toggle-active,
// .date-toggle-active:hover,
// .flag-toggle-active:hover {
//   background-color: rgb(214, 232, 252);
//   border-color: #0058bc;
// }
/* .desktop { */
/* display: flex; */
/* } */
.mobile,
.print-header,
.print-name {
  display: none;
}

/* Responsive */
// @media screen and (max-width: 1200px) {
//   .checkboxes-wrapper {
//     position: static;
//     transform: initial;
//   }
// }
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: inline-grid;
  }
  .inquiry {
    padding: 10px 15px;
  }
  // .inquiry-header {
  //   height: initial;
  // }
  // .inquiry-header-controlls {
  //   display: flex;
  //   flex-direction: column-reverse;
  //   justify-content: center;
  //   width: 100%;
  // }
  .reports-tab {
    font-size: 11px;
  }
  // .date-toggle {
  //   margin: 0 5px;
  // }
  // .inquiry-pre-datepicker-text {
  //   font-size: 20px;
  // }
  // .inquiry-filters-inputs {
  //   display: flex;
  //   flex-direction: column;
  // }
  // .inquiry-filters-btns {
  //   flex-direction: column;
  // }
  // .inquiry-filters-btns .btn {
  //   margin-top: 10px;
  // }
  // .inquiry-datepicker {
  //   margin-top: 10px;
  //   padding: 2px 0;
  //   width: 100%;
  // }
  .new-input-wrapper {
    width: 100%;
  }
  .checkboxes-wrapper {
    margin: 5px 0;
  }
  .table-wrapper {
    overflow: auto;
  }
  .new-content-data-item-toggle-circle {
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    bottom: 75px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.top {
    background-color: #083f75;
    margin-top: 50px;
    position: inherit;
  }
  .new-content-data-item-toggle-circle .tms {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #fff;
    height: 125px;
    padding: 0px;
  }
  .no-wrap {
    white-space: nowrap;
  }
  @media screen and (max-width: 600px) {
    .reports-tab {
      flex-direction: column;
    }
    .reports-tab span:first-child {
      margin: 0;
    }
  }
  @media screen and (max-width: 380px) {
    .reports-tab {
      font-size: 12px;
    }
    .checkboxes-wrapper {
      flex-direction: column;
    }
  }
}

@media print {
  .reports-tabs {
    display: none;
  }

  // .inquiry-header,
  // .inquiry-filters,
  // .inquiry-title-wrapper,
  // .reports-tabs,
  // .print-hide,
  // .switch-wrapper {
  //   display: none;
  // }
  // .inquiry {
  //   padding: 10px;
  //   font-family: Cascadia Code;
  // }
  // .print-header {
  //   align-items: center;
  //   background-color: #f6f6f6;
  //   border-radius: 10px;
  //   font-size: 14px;
  //   display: flex;
  //   justify-content: space-between;
  //   text-align: right;
  //   padding: 15px 22px;
  // }
  // .print-name {
  //   display: block;
  //   font-size: 16px;
  //   padding: 15px;
  //   text-align: center;
  // }
  .reports-content {
    border: initial;
    padding: 0;
  }
  .reports-content .table thead tr {
    background-color: initial !important;
  }
  .reports-content .table thead th {
    background-color: initial !important;
    border-bottom: 1px solid #707070;
    border-top: 1px solid #707070;
    border-radius: 0 !important;
  }
  .reports-content .table tbody tr {
    background-color: initial !important;
  }
  .reports-content .table tbody tr td {
    background-color: initial !important;
    border-bottom: 1px dashed rgba(112, 112, 112, 0.2);
    font-size: 12px;
  }
  .reports-content .table tbody .sum-row td {
    font-weight: 700;
    font-size: 13px;
  }
  .reports-content .table tbody .sum-row td span {
    font-size: 18px;
  }
  .reports-content .table .print-big-td {
    width: 100%;
  }
}
</style>
